export default __webpack_public_path__ + "static/media/plane-ticket-large.a7602ad1.svg";